var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgZw = function SvgZw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h682.67v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#319208",
    d: "M0 438.86h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#de2010",
    d: "M0 292.57h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffd200",
    d: "M0 365.71h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#de2010",
    d: "M0 146.29h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffd200",
    d: "M0 73.143h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#319208",
    d: "M0 0h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.891 0v512l343.77-256L28.891 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 0h29.257v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v512l373.03-256L0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 219.43h1024v73.143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v512l343.77-256L0 0z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d62419",
    fillRule: "evenodd",
    d: "M131.957 114.662l27.271 90.366 97.405.854-77.523 53.863 29.296 92.886-75.178-57.08-79.296 56.566 31.054-89.142-78.309-57.931 94.387 1.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.042 166.226c1.657-2.985 1.988-4.643 10.612-8.292 11.275-32.832 40.129-19.898 56.048 25.537 14.592 6.301 101.814 71.303 100.488 74.951-.663 3.317-11.608.664-11.608.664s-17.245 73.625-17.576 73.625c-32.171-4.311-82.249-4.975-116.411-4.311.331-5.639-9.286-42.451-9.286-42.451s-8.292-2.653 5.638-30.843c14.924-35.485 17.909-93.192-17.908-88.88z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.4676462,
    fill: "#f7df00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55 152.953a3.648 3.648 0 1 1-7.297 0 3.648 3.648 0 0 1 7.296 0zM115.704 183.472s-28.522 16.25-36.813 15.918M205.58 259.084c-1.99-1.659-105.791-6.633-101.484-41.788M120.679 259.745s11.275 6.633 20.892-10.613M133.28 259.414s7.96 7.296 19.568-8.622M62.644 285.95s7.295.995 8.623-3.317M97.126 328.73c0-.331-7.296-47.094-7.296-47.094 36.039 3.206 73.404 3.428 108.113 9.619",
    stroke: "#000",
    strokeWidth: 1.4676462,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.483 282.296l9.948 11.607 10.282-9.95 8.622 9.287M124.993 293.577l8.622-7.628 9.287 8.954M144.551 294.898l9.618-8.622 7.296 8.623M165.451 295.238l8.623-5.97 7.627 7.297M187.672 296.23l6.301-5.97",
    stroke: "#000",
    strokeWidth: 1.4676462,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.821 292.906l10.613 12.272 10.612-9.619 9.286 9.95 10.613-9.286 8.955 10.612 10.944-9.286s8.29 10.281 9.286 10.281 10.944-8.622 10.944-8.622l9.618 10.612 13.265-10.612M93.483 304.847s85.564 3.317 99.492 6.634M107.746 266.05s81.252 4.312 94.187 9.286",
    stroke: "#000",
    strokeWidth: 1.4676462,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16 232.218c.664 4.975-5.306 22.22-11.606 28.19-8.624 6.965-7.629 21.557-7.629 21.557.995 5.97 13.93 5.306 15.588 2.322 1.326-13.598 15.918-16.583 15.918-16.583s20.231-5.637 28.854-22.551M131.95 275.33a4.311 4.311 0 1 1-8.624 0 4.311 4.311 0 0 1 8.623 0zM151.187 276.99a4.311 4.311 0 1 1-8.622.001 4.311 4.311 0 0 1 8.622 0z",
    stroke: "#000",
    strokeWidth: 1.4676462,
    fill: "none"
  }))));
};
export default __webpack_public_path__ + "assets/fee9550021cd5e741f99e42dea693a62.svg";
export { SvgZw as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/zw.svg